import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { loadStripe } from '@stripe/stripe-js/pure';
export default function (_ref, inject) {
  var store = _ref.store,
    $config = _ref.$config;
  inject('stripe', {
    init: function init() {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _store$getters$authC;
        var config, key;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = store.getters['auth/config'];
              if (config) {
                _context.next = 1;
                break;
              }
              _context.next = 1;
              return store.dispatch('auth/fetchConfiguration');
            case 1:
              key = (_store$getters$authC = store.getters['auth/config']) === null || _store$getters$authC === void 0 ? void 0 : _store$getters$authC.stripe_publishable_key;
              if (key) {
                _context.next = 2;
                break;
              }
              throw new Error('No Stripe key for country: ' + store.getters['auth/account'].country);
            case 2:
              _context.next = 3;
              return loadStripe(key);
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  });
}